import { NavLink } from 'react-router-dom';
import { MdOutlineInsights, MdOutlineListAlt } from 'react-icons/md';
import { BRAND } from './constants';

function ActivityNav() {
  return (
    <div
      className="flex items-center gap-1 border-b border-gray-200 mb-5"
      style={{ marginTop: 4 }}
    >
      <NavLink
        to="/activity-tracker"
        end
        className="no-underline"
        style={({ isActive }) => ({
          padding: '12px 18px',
          fontSize: 14,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          color: isActive ? BRAND : '#6B7280',
          fontWeight: isActive ? 600 : 400,
          borderBottom: `2px solid ${isActive ? BRAND : 'transparent'}`,
          marginBottom: -1,
        })}
      >
        <MdOutlineInsights size={18} />
        Overview
      </NavLink>
      <NavLink
        to="/activity-tracker/feed"
        className="no-underline"
        style={({ isActive }) => ({
          padding: '12px 18px',
          fontSize: 14,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          color: isActive ? BRAND : '#6B7280',
          fontWeight: isActive ? 600 : 400,
          borderBottom: `2px solid ${isActive ? BRAND : 'transparent'}`,
          marginBottom: -1,
        })}
      >
        <MdOutlineListAlt size={18} />
        Activity Feed
      </NavLink>
    </div>
  );
}

export default ActivityNav;
